// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__ANaph","boxTitle":"Qualiphy_boxTitle__1CFk5","box":"Qualiphy_box__FcGKI","toggleWrap":"Qualiphy_toggleWrap__2fhdZ"};